<template>
  <v-main class="content">
    <router-view></router-view>
  </v-main>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  background-color: #24292e;
}
</style>